import React from "react";

const chips = [
    "Built for Indian SMEs",
    "GST-ready",
    "E-invoice · IRP",
    "TDS-aware",
    "Multi-currency",
    "Encrypted in transit & at rest",
];

export default function TrustRibbon() {
    return (
        <section className="vy-section-tight" data-testid="landing-trust">
            <div className="vy-container">
                <div className="vy-hair-gold" />
                <div className="vy-reveal" style={{
                    display: "flex", gap: 22, flexWrap: "wrap", justifyContent: "center",
                    padding: "14px 0", fontSize: 11.5, color: "var(--vy-muted)",
                    fontFamily: "IBM Plex Mono, monospace", letterSpacing: "0.06em",
                }}>
                    {chips.map((c, i) => (
                        <span key={c} style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                            <span aria-hidden style={{ color: "var(--vy-gold)" }}>●</span>
                            {c}
                            {i < chips.length - 1 && <span aria-hidden style={{ color: "var(--vy-hair)", marginLeft: 22 }}>│</span>}
                        </span>
                    ))}
                </div>
                <div className="vy-hair-gold" />
            </div>
        </section>
    );
}
